import type { PlayerProfile } from '@brush/api-client';
import type { TickerFact } from '@brush/ui';

/** What the portal's strip says, and about whom. */
export interface PortalTicker {
  label: string;
  /** True when the label is the signed-in player — what earns it signal orange. */
  labelIsSelf: boolean;
  facts: TickerFact[];
}

/**
 * The strip along the portal (#527). Orange means "this is you" on this side of the glass, so it is only ever about the
 * signed-in player: on a portal staff are browsing (`readOnly`), the strip names the player being viewed — which is also
 * what says so on a phone, where the header's *Read only* badge is hidden — and none of its figures is orange. The
 * figures themselves are the same either way; only whose they are changes.
 *
 * The card is the caller's to decide (#494): the player read carries none, so `card` is `ownCardFor`'s answer — the
 * holder's own card beside their own player — and null leaves the strip without one.
 */
export function tickerFor(
  player: Pick<PlayerProfile, 'name' | 'wins' | 'cashes' | 'totalWinnings'>,
  readOnly: boolean,
  card: string | null,
): PortalTicker {
  const self = !readOnly;
  return {
    label: readOnly ? `Viewing · ${player.name}` : 'You',
    labelIsSelf: self,
    facts: [
      ...(card === null ? [] : [{ id: 'card', label: 'card', value: card }]),
      { id: 'wins', label: 'wins', value: player.wins.toLocaleString(), self },
      { id: 'cashes', label: 'cashes', value: player.cashes.toLocaleString(), self },
      { id: 'winnings', label: 'winnings', value: `$${player.totalWinnings.toLocaleString()}`, self },
    ],
  };
}
